module.exports = __webpack_public_path__ + "img/67_26.424d6534.png";